import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { useEffect, useRef } from "react";
import analytics from ".";
var usePageTrack = function(_param) {
    var name = _param.name, category = _param.category, extraProperties = _object_without_properties(_param, [
        "name",
        "category"
    ]);
    var hasAlreadyFiredRef = useRef(false);
    useEffect(function() {
        if (hasAlreadyFiredRef.current) {
            return;
        }
        analytics.page(category, name, extraProperties);
        hasAlreadyFiredRef.current = true;
    }, [
        category,
        name,
        extraProperties
    ]);
};
export default usePageTrack;
